module.exports = __webpack_public_path__ + "img/contility.4f7a708b.svg";